import type { AppKey } from '@iac/contracts';
import { AppCard, AppGrid } from '../components/AppCard';
import { EmptyState } from '../components/EmptyState';
import { AppIconFor } from '../components/icons';
import { PageHeader } from '../components/PageHeader';
import { useDict } from '../i18n/dictionary';
import { shell } from '../i18n/shell';
import { useAuth } from '../lib/auth';

interface AppLink {
  key: AppKey;
  href: string;
}

/** Every app, in launcher order; filtered to the caller's grants below. */
const ALL_APPS: readonly AppLink[] = [
  { key: 'admin', href: '/admin' },
  { key: 'library', href: '/library' },
  { key: 'ag5', href: '/ag5' },
  { key: 'finances', href: '/finances' },
  { key: 'brain', href: '/brain' },
  { key: 'calories', href: '/calories' },
  { key: 'boxer', href: '/boxer' },
  { key: 'recipes', href: '/recipes' },
  { key: 'checklists', href: '/checklists' },
];

export function Apps() {
  const { session } = useAuth();
  const t = useDict(shell);
  const granted = ALL_APPS.filter((a) => session?.apps.includes(a.key));

  return (
    <section className="page-launcher">
      <PageHeader title={t.apps} centered />
      <AppGrid>
        {granted.length > 0 ? (
          granted.map((app) => (
            <AppCard
              key={app.key}
              to={app.href}
              icon={<AppIconFor appKey={app.key} />}
              title={t.appNames[app.key]}
            />
          ))
        ) : (
          <EmptyState>{t.noApps}</EmptyState>
        )}
      </AppGrid>
      <p className="apps-version">
        v{session?.version.split('.').slice(0, 2).join('.')}
      </p>
    </section>
  );
}
